@if (SuppliedQueryData) {
  <div class="container-fluid d-flex flex-column h-100">
    <div class="row">
      <div class="col">
        <label class="fs-26">Files</label>
      </div>
    </div>
    <div class="row-padding-bottom row">
      <div class="col"></div>
      <div class="col-2">
        <button class="btn btn-primary" (click)="uploadFile()">Add file</button>
      </div>
    </div>
    <div class="row flex-grow-1">
      <div class="col">
        <app-site-vendor-files-grid
          [gridName]="'SiteVendorFiles'"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [suppliedQueryData]="SuppliedQueryData"
          [(reloadGridData)]="reloadSiteVendorFileGridData"
          (actionEvent)="action($event)"
        ></app-site-vendor-files-grid>
      </div>
    </div>
  </div>
}
